import React from 'react';
export function Footer() {
  return <footer className="bg-[#080D15] px-5 py-6 md:py-8 text-center" data-id="element-62">
      <p className="font-montserrat text-[12px] leading-[1.8] text-white/30" data-id="element-63">
        🦷 <strong className="text-white/50" data-id="element-64">KIT CONSULTORIO EN ORDEN™</strong>
        <br data-id="element-65" />
        El sistema de protocolos clínicos N°1 para odontólogos independientes en
        Argentina.
        <br data-id="element-66" />
        Porque sistematizar tu consultorio no debería costarte meses ni una
        consultoría cara.
        <br data-id="element-67" />
        <br data-id="element-68" />
        <a href="mailto:contacto@solucionesya.shop" className="text-white/40 no-underline hover:text-white/60" data-id="element-69">
          contacto@solucionesya.shop
        </a>{' '}
        ·{' '}
        <a href="#" className="text-white/40 no-underline hover:text-white/60" data-id="element-70">
          @solucionesya.shop
        </a>{' '}
        ·{' '}
        <a href="#" className="text-white/40 no-underline hover:text-white/60" data-id="element-71">
          solucionesya.shop
        </a>
        <br data-id="element-72" />
        <br data-id="element-73" />© Solucionesya.shop™ 2026 — Todos los derechos reservados.
      </p>
    </footer>;
}